import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Meta } from "../../Components/Helpers/Meta";
import { Navbar } from "../../Components/Navbar/Navbar";
import v31Preview from "../../assets/certificates/asi/asi-performance-standard-v3-1-2023.png";
import v3Preview from "../../assets/certificates/asi/asi-performance-standard-v3-2022.png";
import v2Preview from "../../assets/certificates/asi/asi-performance-standard-v2-2017.png";
import "./AluminiumStewardshipInitiative.css";

// Previews are the first pages of the original certificate PDFs linked below.
const certificates = [
  {
    label: "sustainability-asiV3.1",
    pdf: "https://www.cevher.com/static/docs/ASI-CertificateV-3.1.pdf",
    preview: v31Preview,
  },
  {
    label: "sustainability-asiV3",
    pdf: "https://www.cevher.com/static/docs/ASI-CertificateV3.pdf",
    preview: v3Preview,
  },
  {
    label: "sustainability-asiV2",
    pdf: "https://www.cevher.com/static/docs/ASI-CertificateV2.pdf",
    preview: v2Preview,
  },
];

const AluminiumStewardshipInitiative = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const title = t("aluminium-stewardship-initiative");

  return (
    <div>
      <Meta title={title} description={t("asi-certificates-description")} lang={lang} />
      <Navbar />
      <main className="c-wrapper asi-page">
        <div className="c-hero">
          <div className="c-hero-background">
            <img
              className="c-hero-image"
              alt=""
              src={require("../../assets/hero/sustainability-report.93d2f60c.jpg")}
            />
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section">{t("sustainability")}</div>
              <h1 className="c-caption-header">{title}</h1>
            </div>
          </div>
        </div>
        <section className="c-container asi-certificates" aria-labelledby="asi-certificates-heading">
          <h2 id="asi-certificates-heading">{t("asi-certificates")}</h2>
          <p>{t("asi-certificates-description")}</p>
          <ul className="c-list asi-certificate-list">
            {certificates.map(({ label, pdf }) => (
              <li className="c-list-item" key={label}>
                <a
                  href={pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("asi-open-certificate", { certificate: t(label) })}
                >
                  {t(label)}
                </a>
              </li>
            ))}
          </ul>
          <div className="asi-certificate-gallery">
            {certificates.map(({ label, pdf, preview }) => (
              <figure className="asi-certificate" key={label}>
                <a
                  href={pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t("asi-open-certificate", { certificate: t(label) })}
                >
                  <img
                    src={preview}
                    alt={t(label)}
                    width="1132"
                    height="1600"
                    loading="lazy"
                  />
                </a>
                <figcaption>{t(label)}</figcaption>
              </figure>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default AluminiumStewardshipInitiative;
